export default __webpack_public_path__ + "static/media/lock.2319be16.svg";